import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CartProvider } from 'react-use-cart';
import { PromoProvider } from './providers/Init';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ThreeDSRoutes from "./providers/3ds/ThreeDSRoutes";
import Websocket from './providers/Websocket';
import ThankYou from './Pages/ThankYou';
import Preland from './components/Preland/Preland';
import Details from './components/Details';
import Adress from './components/Adress';
import Addcard from './components/Addcard';
import MapManual from './components/MapManual';
import { useTranslation } from 'react-i18next';
import Main from './Main';
import PromoOverlay from './PromoOverlay';
import Loader from './Loader';
import useSnapPixel from "./providers/UseSnapchatPixel"


const RootComponent = () => {
  const { i18n } = useTranslation();

  // Set HTML direction dynamically
  useEffect(() => {
    document.documentElement.setAttribute("dir", i18n.language === "ar" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", i18n.language); // Set language attribute
  }, [i18n.language]);


  useSnapPixel()
  return (
    <Router>
      <PromoProvider>
        <CartProvider>
      <PromoOverlay />
      {/* <Loader /> */}
          <Websocket />
          <Routes>
            <Route path='/' element={<Main />} />
            <Route path='/restraunt/:id' element={<App />} />
            <Route path='/cart' element={<Preland />} />
            <Route path='/details' element={<Details />} />
            <Route path='/map' element={<MapManual />} />
            <Route path='/addcard' element={<Addcard />} />
            <Route path='/ThankYou' element={<ThankYou />} />
            {ThreeDSRoutes()}
          </Routes>
        </CartProvider>
      </PromoProvider>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);
